/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type TranslationExerciseAnalysis_exercise = {
    readonly content: {
        readonly prompt: string;
        readonly correctAnswers: ReadonlyArray<string>;
        readonly scrambledParts: ReadonlyArray<string>;
    };
    readonly " $refType": "TranslationExerciseAnalysis_exercise";
};
export type TranslationExerciseAnalysis_exercise$data = TranslationExerciseAnalysis_exercise;
export type TranslationExerciseAnalysis_exercise$key = {
    readonly " $data"?: TranslationExerciseAnalysis_exercise$data;
    readonly " $fragmentRefs": FragmentRefs<"TranslationExerciseAnalysis_exercise">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "TranslationExerciseAnalysis_exercise",
  "type": "TranslationExercise",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "content",
      "storageKey": null,
      "args": null,
      "concreteType": "TranslationExerciseContent",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "prompt",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "correctAnswers",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "scrambledParts",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = '69f74a01c3b19efe3951066d6ee4d205';
export default node;
